import { z } from 'zod';

import { columnBaseSchema } from '../base';
import {
    columnAnimationSchema,
    columnBackgroundSchema,
    columnBorderSchema,
    columnHorizontalAlignSchema,
    columnRadiusSchema,
    columnScrollEffectSchema,
    columnShadowSchema,
    columnWidthSchema,
    columnVerticalAlignSchema,
} from '../shared';
import { responsiveSpacingSchema } from '../../../mixins';

/**
 * An ordinary column — the only styleable one. Legacy spread these across four
 * loose bags (`data`/`styles` plus a mobile and a tablet copy of each) and
 * thirty-odd flat keys; v0 groups them by what the user edits and pushes the
 * breakpoint down to the leaf that actually varies.
 *
 * `width` and `syncWithDesktop` stay flat on purpose: a width and the
 * "same styles on every device" switch have no meaning per breakpoint.
 */
export const columnDefaultDataSchema = z.object({
    width: columnWidthSchema,
    /** Write desktop edits through to mobile and tablet. */
    syncWithDesktop: z.boolean(),

    verticalAlign: columnVerticalAlignSchema,
    horizontalAlign: columnHorizontalAlignSchema,

    padding: responsiveSpacingSchema,
    borderRadius: columnRadiusSchema,
    border: columnBorderSchema,
    background: columnBackgroundSchema,

    shadow: columnShadowSchema,
    scrollEffect: columnScrollEffectSchema,
    animation: columnAnimationSchema,
});

export const columnDefaultSchema = columnBaseSchema.extend({
    entitySubType: z.literal('default'),
    props: columnDefaultDataSchema,
    version: z.literal(0),
});

export const columnDefaultV0Schema = columnDefaultSchema;
export type ColumnDefaultV0 = z.infer<typeof columnDefaultV0Schema>;
